import React, {Component} from 'react'
import { withRouter } from 'react-router-dom'
import asyncWrapper from '../../../../../shared/javascripts/hocs/asyncWrapper'
import { Panel } from 'react-bootstrap'
import Loading from '../../../../../shared/javascripts/components/Loading'
import LoadingError from '../../../../../shared/javascripts/components/LoadingError'
import MonitoringApi from '../../api/MonitoringApi'
import ServerPanel from './ServerPanel'
import DataPanel from './DataPanel'

class TabContent extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    MonitoringApi.statuses('shogun')
      .then(this.props.handleErrors)
      .then(response => {
        this.props.saveShogunData(response)
      }).then(() => this.props.setLoading()).catch(error => console.log(error))
  }

  render() {
    if(this.props.loading) { return <Loading />}
    const shogunData = this.props.shogunData;
    if(shogunData.error || shogunData.data.source_error) {return <LoadingError message={shogunData.error || shogunData.data.source_error} />}
    return(
      <div className='TabContent'>
        <ServerPanel data={shogunData.data} />
        <DataPanel data={shogunData.data} />
      </div>
    )
  }
}

export default asyncWrapper(withRouter(TabContent))


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/Shogun/TabContent.jsx